import { render, staticRenderFns } from "./quotation-part-price-tab.vue?vue&type=template&id=cb4540f0&scoped=true"
import script from "./quotation-part-price-tab.vue?vue&type=script&lang=js"
export * from "./quotation-part-price-tab.vue?vue&type=script&lang=js"
import style0 from "./quotation-part-price-tab.vue?vue&type=style&index=0&id=cb4540f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb4540f0",
  null
  
)

export default component.exports